<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-edit-form ref="edit_profile" header-color="green"> </user-edit-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-application-form ref="user_application_form" header-color="green">
      </user-application-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-wishlist-form ref="wish_list_form" header-color="green">
      </user-wishlist-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-info-edit-form ref="edit_info_profile" header-color="green">
      </user-info-edit-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-document-form ref="edit_document_profile" header-color="green">
      </user-document-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-other-file-form ref="edit_other_file" header-color="green">
      </user-other-file-form>
    </div>
  </div>
</template>
<script>
import UserEditForm from "./UserStudentUpdateComponent/UserEditForm";
import UserApplicationForm from "./UserStudentUpdateComponent/UserApplicationForm";
import UserWishlistForm from "./UserStudentUpdateComponent/UserWishlistForm";
import UserInfoEditForm from "./UserStudentUpdateComponent/UserInfoEditForm";
import UserDocumentForm from "./UserStudentUpdateComponent/UserDocumentForm";
import UserOtherFileForm from "./UserStudentUpdateComponent/UserOtherFileForm";

export default {
  data() {
    return {
      wizardModel: {},
      userID: null
    };
  },
  components: {
    UserEditForm,
    UserApplicationForm,
    UserWishlistForm,
    UserInfoEditForm,
    UserDocumentForm,
    UserOtherFileForm
  },
  mounted() {
    this.userID = this.$route.params.id;
    // Student user
    let role = 2;
    this.$store.getUser(role, this.userID).then(response => {
      // edit_profile
      this.$refs["edit_profile"].userID = response.data.id;

      this.$refs["edit_profile"].first_name = response.data.first_name;
      this.$refs["edit_profile"].last_name = response.data.last_name;
      this.$refs["edit_profile"].email = response.data.email;
      this.$refs["edit_profile"].picture = response.data.picture;
      this.$refs["edit_profile"].title = response.data.title;
      if (response.data.gender === "Male") {
        this.$refs["edit_profile"].gender = "M";
      } else {
        this.$refs["edit_profile"].gender = "F";
      }
      this.$refs["edit_profile"].mobile_phone = response.data.mobile_phone;
      this.$refs["edit_profile"].country = response.data.country
        ? response.data.country.id
        : null;
      this.$refs["edit_profile"].is_active = response.data.is_active;
      // edit_info_profile
      this.$refs["edit_info_profile"].userID = response.data.id;
      if (response.data.info) {
        this.$refs["edit_info_profile"].mother_name =
          response.data.info.mother_name;
        this.$refs["edit_info_profile"].father_name =
          response.data.info.father_name;
        this.$refs["edit_info_profile"].birth_date =
          response.data.info.birth_date;
        this.$refs["edit_info_profile"].country_of_birth =
          response.data.info.country_of_birth;
        this.$refs["edit_info_profile"].nationality =
          response.data.info.nationality;
        this.$refs["edit_info_profile"].passport_number =
          response.data.info.passport_number;
        this.$refs["edit_info_profile"].passport_date_of_expire =
          response.data.info.passport_date_of_expire;
        this.$refs["edit_info_profile"].passport_date_of_issue =
          response.data.info.passport_date_of_issue;
        this.$refs["edit_info_profile"].country_of_residence =
          response.data.info.country_of_residence;
        this.$refs["edit_info_profile"].city_of_residence =
          response.data.info.city_of_residence;
        this.$refs["edit_info_profile"].address = response.data.info.address;
        this.$refs["edit_info_profile"].whatsapp_number =
          response.data.info.whatsapp_number;
        this.$refs["edit_info_profile"].need_visa =
          response.data.info.need_visa;
        this.$refs["edit_info_profile"].agency = response.data.info.agency;
        // edit_document_profile
        this.$refs["edit_document_profile"].picture = response.data.picture;
        this.$refs["edit_document_profile"].passport =
          response.data.info.passport;
        this.$refs["edit_document_profile"].diploma =
          response.data.info.diploma;
        this.$refs["edit_document_profile"].transcript =
          response.data.info.transcript;
        this.$refs["edit_document_profile"].cv = response.data.info.cv;
      }
      // user_application_form
      this.$refs["user_application_form"].first_name = response.data.first_name;
      this.$refs["user_application_form"].last_name = response.data.last_name;
    });
  }
};
</script>
